<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.operation_type') }}</label></td>
      <td>{{ details.operation_type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.merchant_reference') }}</label></td>
      <td>{{ details.merchant_reference }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.bearer_id') }}</label></td>
      <td>{{ details.bearer_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.bearer_type') }}</label></td>
      <td>{{ details.bearer_type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.account_id') }}</label></td>
      <td>
        <router-link v-if="details.deleted_at"
                     :to="{name: 'account-pos-operations', params: {id: details.account_id}}">
          {{ details.account_id }}
        </router-link>
        <router-link v-else-if="details.operation_type == 'card_sell'"
                     :to="{name: 'account-profile', params: {id: details.account_id}}">
          {{ details.account_id }}
        </router-link>
        <router-link v-else
                     :to="{name: 'account-top-ups-details', params: {id: details.account_id, top_up_id: details.id}}">
          {{ details.account_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.card_identity_id') }}</label></td>
      <td>{{ details.card_identity_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.amount') }}</label></td>
      <td><span v-if="details.amount">{{ details.amount | money }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.discount_id') }}</label></td>
      <td>{{ details.discount_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.additional_details') }}</label></td>
      <td>{{ details.additional_details }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.processing_status') }}</label></td>
      <td>{{ details.processing_status }} <span v-if="details.deleted_at">({{ $t('generic.deleted') }})</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.processed_at') }}</label></td>
      <td><span v-if="details.processed_at">{{ details.processed_at | time }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.parent_operation_id') }}</label></td>
      <td>{{ details.parent_operation_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posOperationDetails.pos_transaction_id') }}</label></td>
      <td>
        <router-link :to="{name: 'pos-transaction', params: {id: details.pos_transaction_id}}">
          {{ details.pos_transaction_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.deleted') }}</label></td>
      <td><span v-if="details.deleted_at">{{ details.deleted_at | time }}</span></td>
    </tr>
  </table>
</template>
<script>
import linkUtils from "@/util/link_utils";

export default {
  name: 'posOperationDetails',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  methods: {
    accountTopUpLinkUrl(id) {
      return linkUtils.accountProfilePath(this.$router, {account_id: id});
    },
  }
};
</script>
<style></style>
